import React from 'react';

const Logo = () => {
    return (
        <img
            src="/logoMevam.png"
            alt="Logo MEVAM"
            className="object-contain h-16 md:h-20 w-auto"
            style={{ maxWidth: '280px' }}
        />
    );
};

export default Logo;
